export const stageOrder = [
  "planning_initiation",
  "expansion_preparation",
  "market_expansion",
  "launch_preparation",
  "launch_sales",
  "stable_sales",
  "phase_out",
];

export const stageLabels = {
  planning_initiation: "规划与立项",
  expansion_preparation: "拓展准备",
  market_expansion: "市场拓展",
  launch_preparation: "上市准备",
  launch_sales: "上市销售",
  stable_sales: "稳定销售",
  phase_out: "退市操盘",
};

export const stageGateLabels = {
  planning_initiation: "CDCP/GR1通过",
  expansion_preparation: "PDCP/GR2通过",
  market_expansion: "GR3样机与拓展包就绪",
  launch_preparation: "TR4A/TR5/GR4通过",
  launch_sales: "ADCP/GR5产品上市",
  stable_sales: "GR5A经营复盘完成",
  phase_out: "EOX/GR6退市复盘完成",
};

export const statusLabels = {
  normal: "正常",
  at_risk: "风险",
  delayed: "延期",
  paused: "暂停",
  completed: "已结项",
  not_started: "未开始",
  in_progress: "进行中",
  pending_review: "待评审",
  completed_task: "已完成",
  canceled: "已取消",
  blocked: "阻塞",
  preparing: "准备中",
  basically_ready: "基本就绪",
  ready: "已就绪",
  approved: "通过",
  conditionally_approved: "有条件通过",
  deferred: "暂缓",
  rejected: "不通过",
  open: "开放",
  closed: "已关闭",
};

export function isTaskOverdue(task, today = new Date()) {
  if (task.status === "completed_task" || task.status === "canceled") return false;
  return new Date(task.dueDate) < today;
}

export function calculateReadinessSummary(items) {
  const total = items.length || 1;
  const readyLike = items.filter((item) => item.status === "ready" || item.status === "basically_ready").length;
  const blocked = items.filter((item) => item.status === "blocked").length;
  return {
    score: Math.round((readyLike / total) * 100),
    blocked,
    total,
    readyLike,
  };
}

export function deriveProjectHealth(project, tasks, risks, readinessItems) {
  const overdue = tasks.filter((task) => task.projectId === project.id && isTaskOverdue(task)).length;
  const criticalRisks = risks.filter(
    (risk) => risk.projectId === project.id && risk.status !== "closed" && (risk.priority === "P0" || risk.priority === "P1")
  ).length;
  const blockedReadiness = readinessItems.filter((item) => item.projectId === project.id && item.status === "blocked").length;

  if (criticalRisks > 0 || blockedReadiness > 0) return "at_risk";
  if (overdue > 0) return "delayed";
  return project.status;
}

export function nextStageKey(currentStage) {
  const index = stageOrder.indexOf(currentStage);
  if (index < 0 || index === stageOrder.length - 1) return null;
  return stageOrder[index + 1];
}

export function canMoveToNextStage(project, reviews, readinessItems) {
  const current = project.currentStage;
  const next = nextStageKey(current);
  if (!next) return { allowed: false, reason: "当前已经是最后阶段" };

  const requiredReviewByStage = {
    planning_initiation: "initiation_review",
    expansion_preparation: "launch_path_review",
    launch_preparation: "launch_readiness_review",
    launch_sales: "first_sales_review",
  };

  const requiredReview = requiredReviewByStage[current];
  if (requiredReview) {
    const review = reviews.find((item) => item.projectId === project.id && item.reviewType === requiredReview);
    if (!review || (review.decision !== "approved" && review.decision !== "conditionally_approved")) {
      return { allowed: false, reason: "关键评审尚未通过" };
    }
  }

  if (current === "launch_preparation") {
    const blocked = readinessItems.some((item) => item.projectId === project.id && item.status === "blocked");
    if (blocked) return { allowed: false, reason: "上市准备仍有阻塞项" };
  }

  return { allowed: true, reason: "满足阶段流转条件" };
}

export function groupBy(items, keyGetter) {
  return items.reduce((acc, item) => {
    const key = keyGetter(item);
    acc[key] = acc[key] || [];
    acc[key].push(item);
    return acc;
  }, {});
}
